'use client';

import logger from 'logger';
import { useState } from 'react';

import { useContractApi } from '~/data/api';

export const useDownloadContract = ({ contractNumber }: { contractNumber: string }) => {
  const { getContractFile } = useContractApi();
  const [isDownloading, setIsDownloading] = useState(false);

  const download = async () => {
    setIsDownloading(true);

    try {
      const { contractDownloadUrl } = await getContractFile({ contractNumber });
      window.open(contractDownloadUrl, '_blank', 'noopener noreferrer');

      setIsDownloading(false);
    } catch {
      logger.debug('Contract file not found');
      setIsDownloading(false);
    }
  };

  return { download, isDownloading };
};
